// Locale messages are lazy-loaded per locale (see `i18n.locales[].file` +
// `lazy: true` in nuxt.config.ts), so they are not imported here.
export default defineI18nConfig(() => ({
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
}));
